require("es6-promise").polyfill();
require("isomorphic-fetch");
import authStore from "../modules/auth/AuthModel";
import { concatQuery } from "./query-string";
export interface IRequestOptions {
  queries?: any;
  body?: {};
  file?: boolean;
}
const request = async (
  method: string,
  endpoint: string,
  options: IRequestOptions
) => {
  let url = "";
  const accessToken = window.localStorage.getItem("access_token") || "";
  const requestOptions: RequestInit = {
    method,
    headers: {
      // Accept: "application/json",
      Accept: "*/*",
      "Content-Type": "application/json",
      Authorization: accessToken ? `Bearer ${accessToken}` : "",
      UserId:
        authStore.userProfile && authStore.userProfile.id
          ? authStore.userProfile.id
          : "",

    }
  };
  if (method === "GET") {
    url = options.queries
      ? `${endpoint}?${concatQuery(options.queries)}`
      : endpoint;
  }
  if (method === "POST" || method === "PUT") {
    url = endpoint;
    requestOptions.body = setBody(options.body);
  }
  if (method === "DELETE") {
    url = options.queries
      ? `${endpoint}?${concatQuery(options.queries)}`
      : endpoint;
    if (options.body) requestOptions.body = setBody(options.body);
  }
  try {
    console.log("url", url, requestOptions);
    const res = await fetch(url, requestOptions);

    if (options.file) {
      const contentType = res.headers.get("Content-Type");
      console.log(contentType);
      const contentDisposition = res.headers.get("Content-Disposition");
      console.log(contentDisposition);
      if(contentType=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"){

        await downloadFileWord(res);
      }else{

        await downloadFile(res);
      }
      return;
    }

    if (res.status === 404) {
      throw {
        code: "",
        name: "พบข้อผิดพลาดจากระบบหลังบ้าน",
        message: "กรุณาติดต่อผู้ดูแลระบบค่ะ",
        technicalStack: ""
      };
    }
    if (res.status === 405) {
      /// for test
      throw {
        code: "",
        name: "ไม่พบระบบหลังบ้าน",
        message: "กรุณาติดต่อผู้ดูแลระบบค่ะ",
        technicalStack: ""
      };
    }
    const resJson = await res.json();
    switch (res.status) {
      case 200:
        if (resJson.hasOwnProperty("isCompleted") && resJson.isCompleted) {
          return resJson;
        } else {
          throw {
            code: resJson.message[0].code,
            name: resJson.message[0].messageType,
            message: resJson.message[0].message,
            technicalStack: resJson.message[0].messageHint
          };
        }
      case 400:
        throw {
          code: "ไม่ผ่านเงื่อนไขการตรวจสอบ",
          name: resJson.title,
          message: JSON.stringify(resJson.errors),
          technicalStack: JSON.stringify(resJson.errors)
        };

      case 401:
        throw {
          code: "AuthError",
          name: resJson.title,
          message: JSON.stringify(resJson.errors),
          technicalStack: JSON.stringify(resJson.errors)
        };
      case 500:
        throw {
          code: resJson.message[0].code,
          name: resJson.message[0].messageType,
          message: resJson.message[0].message,
          technicalStack: resJson.message[0].messageHint
        };

      default:
        throw {
          code: "",
          name: "พบข้อผิดพลาดจากระบบหลังบ้าน",
          message: "กรุณาติดต่อผู้ดูแลระบบค่ะ",
          technicalStack: ""
        };
    }
  } catch (e) {
    // กรณีไม่ได้ต่ออินเตอร์เน็ต
    if (!e.code && e.name === "TypeError") {
      throw {
        code: "ไม่สามารถเชื่อมต่อระบบได้",
        name: "ไม่สามารถเชื่อมต่อระบบได้",
        message: "เครือข่ายสื่อสารขัดข้อง",
        technicalStack: "ไม่สามารถเชื่อมต่อระบบเนื่องจากเครือข่ายสื่อสารขัดข้อง"
      };
    }
    throw e;
  }
};

const setBody = (body: any) => {
  return JSON.stringify(body);
};

const downloadFile = async (res: Response) => {
  const urlArray = res.url.split("/");
  const data = await res.blob();
  const fUrl = window.URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = fUrl;
  link.setAttribute("download", `${urlArray[urlArray.length - 1]}.xlsx`);
  document.body.appendChild(link);
  link.click();
  return;
};
const downloadFileWord = async (res: Response) => {
  const urlArray = res.url.split("/");
  const data = await res.blob();
  const fUrl = window.URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = fUrl;
  link.setAttribute("download", `${urlArray[urlArray.length - 1]}.docx`);
  document.body.appendChild(link);
  link.click();
  return;
};


const get = (endpoint: string, requestOptions: IRequestOptions) =>
  request("GET", endpoint, requestOptions);
const post = (endpoint: string, requestOptions: IRequestOptions) =>
  request("POST", endpoint, requestOptions);
const put = (endpoint: string, requestOptions: IRequestOptions) =>
  request("PUT", endpoint, requestOptions);
const remove = (endpoint: string, requestOptions: IRequestOptions) =>
  request("DELETE", endpoint, requestOptions);
const getFile = (endpoint: string, requestOptions: IRequestOptions) =>
  request("GET", endpoint, requestOptions);
export { get, post, put, remove as delete, getFile };
